import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'

const EMAIL_TEMPLATE_MODEL_CLASS_NAME = 'EmailTemplate'

const EMAIL_TEMPLATE_MODEL_KEY = {
  TITLE: 'title',
  SUBJECT: 'subject',
  CONTENT: 'content',
  CATEGORIES: 'categories',
  TAGS: 'tags',
  // Virtual
  PREVIEW: 'preview'
}

/**
 * A list of required attributes.
 * @type {String[]}
 */
const EMAIL_TEMPLATE_MODEL_KEYS_REQUIRED = [
  EMAIL_TEMPLATE_MODEL_KEY.PREVIEW
]
const EMAIL_TEMPLATE_MODEL_VALIDATOR = {
  [EMAIL_TEMPLATE_MODEL_KEY.TITLE]: [
    5,
    50
  ],
  [EMAIL_TEMPLATE_MODEL_KEY.SUBJECT]: [
    5,
    50
  ],
  [EMAIL_TEMPLATE_MODEL_KEY.CATEGORIES]: [
    0,
    2
  ],
  [EMAIL_TEMPLATE_MODEL_KEY.TAGS]: [
    0,
    6
  ]
}

const EMAIL_TEMPLATE_MODEL_PLACEHOLDER = {
  [EMAIL_TEMPLATE_MODEL_KEY.TAGS]: 'tag1, tag2, tag3',
  [EMAIL_TEMPLATE_MODEL_KEY.CATEGORIES]: 'category1, category2, category3',
  [EMAIL_TEMPLATE_MODEL_KEY.TITLE]: 'Test',
  [EMAIL_TEMPLATE_MODEL_KEY.SUBJECT]: 'Test Email',
  [EMAIL_TEMPLATE_MODEL_KEY.CONTENT]: '<td><tr><p class="alignleft">Test</p></tr></td>'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const EMAIL_TEMPLATE_MODEL_ASSOCIATION = {
  [EMAIL_TEMPLATE_MODEL_KEY.CATEGORIES]: CATEGORY_MODEL_CLASS_NAME,
  [EMAIL_TEMPLATE_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME
}

export {
  EMAIL_TEMPLATE_MODEL_CLASS_NAME,
  EMAIL_TEMPLATE_MODEL_KEY,
  EMAIL_TEMPLATE_MODEL_KEYS_REQUIRED,
  EMAIL_TEMPLATE_MODEL_VALIDATOR,
  EMAIL_TEMPLATE_MODEL_PLACEHOLDER,
  EMAIL_TEMPLATE_MODEL_ASSOCIATION
}
